import Axios from "../utils/request";
// 首页 获取数据
export const queryloanstatus = (data) =>
  Axios({
    url: "/loan/queryloanstatus",
    method: "post",
    data,
  });

// 获取产品列表
export const queryproducts2 = (data) =>
  Axios({
    url: "/loan/queryproducts2",
    method: "post",
    data,
  });

// 提交前确认信息
export const confirm = (data) =>
  Axios({
    url: "/loan/confirm",
    method: "post",
    data,
  });

// 首页 申请贷款
export const loanapp = (data) =>
  Axios({
    url: "/loan/loanapp",
    method: "post",
    data,
  });
// 信息完整度查询
export const userStatus = (data) =>
  Axios({
    url: "/tw/user/userStatus",
    method: "post",
    data,
  });
// 运营商查询
export const getAuthStatus = (data) =>
  Axios({
    url: "/vayHub/getAuthStatus",
    method: "post",
    data,
  });
// 首页 贷款申请校验
export const vayHub = (data) =>
  Axios({
    url: "/vayHub/auth",
    method: "post",
    data,
  });
// 首页 贷款申请校验
export const vayHubFirst = (data) =>
  Axios({
    url: "/vayHub/first",
    method: "post",
    data,
  });
// 首页 贷款申请校验
export const vayHubSecond = (data) =>
  Axios({
    url: "/vayHub/second",
    method: "post",
    data,
  });

// 首页 是否跳转确认订单页
export const judgeJump = (data) =>
  Axios({
    url: "/app/order/judgeJump",
    method: "get",
    data,
  });

// 首页 查询产品
export const queryproductsSaas = (data) =>
  Axios({
    url: "/loan/saas/queryproductsSaas",
    method: "post",
    data,
  });
// 首页 老客申请
export const loanApply = (data) =>
  Axios({
    url: "/tw/loan/apply",
    method: "post",
    data,
  });
// 首页 确认弹窗
export const saasConfirm = (data) =>
  Axios({
    url: "/loan/saas/confirm",
    method: "post",
    data,
  });
// 首页 申请
export const saasLoanapp = (data) =>
  Axios({
    // url: "/loan/saas/loanapp",
    url: "/loan/application/submit",
    method: "post",
    data,
  });
